import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainContainer from "../../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import IosSwitchMain from "../../../components/iosSwitchMain";
import SearchBar from "../../../components/SearchBar";
import {
  isValidEmail,
  isValidInput,
  isValidNumber,
} from "../../../utils/validations";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import DeleteIcon from "@mui/icons-material/Delete";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useLazyAllMembersQuery } from "../../../service/user";
import { useLazyGetDietaryQuery } from "../../../service/cms";
import { showError, showToast } from "../../../constants/toasts";
import dayjs, { Dayjs } from "dayjs";
import {
  useAddComplimentaryBookingMutation,
  useAddPaidBookingMutation,
  useAddUserForDiningMutation,
  useAddUserForEventMutation,
  useInviteUserBookingMutation,
  useLazyGetBookingMembersQuery,
  useLazyGetCancelledOfferMembersQuery,
  useLazyGetCancelledOffersQuery,
  useLazyGetOfferByIdQuery,
  useLazyGetUserDetailByEmailQuery,
} from "../../../service/offer";
import useAuth from "../../../hooks/useAuth";
import Loader from "../../../constants/Loader";
import { OFFER_TYPE, USER_STATUS } from "../../../utils/enums";
import ReactQuill from "react-quill";
import { Offer } from "../../../types/General";
import { useEditBookingMutation } from "../../../service/booking";

type User =
  | {
      userId: string;
      name: string;
      email: string;
      membershipType: string;
      membership: string;
      createdAt: string;
      paymentStatus: string;
      phoneNumber: string;
    }
  | any;

type InputType = "Checkbox" | "Radio" | "Text" | "TextArea" | "Date";

interface Option {
  id: number;
  optionText: string;
}

interface Question {
  answer: any;
  id: number;
  label: string;
  inputType: InputType;
  options: Option[];
}

interface Answer {
  questionId: number;
  textValue: string;
  selectedOptionId: number;
  selectedOptionIds: number[];
  numberValue: number;
}

type SelectedUser = {
  name: string;
  email: string;
  roles: string;
};

function AddUserLink() {
  const location = useLocation();
  const { state } = location;
  const questions: Question[] = state?.questions || [];
  const offerStartDate = state?.offerStartDate || "";
  const offerEndDate = state?.offerEndDate || "";
  const offerId = state?.offerId || "";
  const isCancellationPolicy = state?.isCancellationPolicy || false;
  const numberOfGuest = state?.numberOfGuest || "";
  const eventType = state?.eventType || "";
  const price = state?.price || "0";
  const isGuestAdded = state?.isGuestAdded || false;
  const isdiningforOther = state?.isdiningforOther || false;
  const advanceBookingPeriod = state?.advanceBookingPeriod || "";
  const isEdit = state?.isEdit || false;
  const clientEmail = state?.clientEmail || "";
  const clientName = state?.clientName || "";
  const bookingId = state?.bookingId || "";
  const bookingDate = state?.bookingDate || "";
  const isPartnerAdded = state?.isPartnerAdded || false;
  const specialRequestState = state?.specialRequest || "";
  const guestDetails = state?.guestDetails || [];
  const contactDealerAmount = state?.contactDealerAmount || "";
  const contactDealerNotes = state?.contactDealerNotes || "";

  let maxAllowedDate = null;
  if (advanceBookingPeriod?.includes("Week")) {
    const weeks = parseInt(advanceBookingPeriod); // extract number
    maxAllowedDate = dayjs().add(weeks, "week");
  } else if (advanceBookingPeriod?.includes("Month")) {
    const months = parseInt(advanceBookingPeriod); // extract number
    maxAllowedDate = dayjs().add(months, "month");
  }

  const finalMaxDate = maxAllowedDate
    ? dayjs(offerEndDate).isBefore(maxAllowedDate)
      ? dayjs(offerEndDate)
      : maxAllowedDate
    : dayjs(offerEndDate);

  const navigate = useNavigate();
  const [getUsers] = useLazyAllMembersQuery();
  const [getDietary] = useLazyGetDietaryQuery();
  const [addUser] = useAddUserForDiningMutation();
  const [addUserForEvent] = useAddUserForEventMutation();
  const [cancelledOffers] = useLazyGetCancelledOffersQuery();
  const [complimentaryBooking] = useAddComplimentaryBookingMutation();
  const [inviteBooking] = useInviteUserBookingMutation();
  const [userByEmail] = useLazyGetUserDetailByEmailQuery();
  const [bookingMembers] = useLazyGetBookingMembersQuery();
  const [getOfferDetail] = useLazyGetOfferByIdQuery();
  const [editBooking] = useEditBookingMutation();
  const [cancelledOfferMembers] = useLazyGetCancelledOfferMembersQuery();
  const [addPaidBooking] = useAddPaidBookingMutation();
  const userData = useAuth();

  const [type, setType] = useState("");
  const [type1, setType1] = useState("");

  const [isAdvanceBooking, setIsAdvanceBooking] = useState(false);
  const [isPartnerIncluded, setIsPartnerIncluded] = useState(false);
  const [isGuestIncluded, setIsGuestIncluded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<User[]>([]);
  const [previousOffer, setPreviousOffers] = useState<any[]>([]);
  const [dietary, setDietary] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState<string | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<string[]>([]);
  const [name, setName] = useState("");
  const [date, setDate] = useState<Dayjs | null>(null);
  const [time, setTime] = useState<Dayjs | null>(null);
  const [error, setError] = useState(false);
  const [guests, setGuests] = useState(isEdit ? "" : "1");
  const [partnerEmail, setPartnerEmail] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [selectedPartnerPlan, setSelectedPartnerPlan] = useState<string[]>([]);
  const [answers, setAnswers] = useState<Answer[]>([]);
  const [specialRequest, setSpecialRequest] = useState("");
  const [selectedOffer, setSelectedOffer] = useState("");
  const [selectedUsers, setSelectedUsers] = useState<SelectedUser[]>([]);
  const [inviteUserName, setInviteUserName] = useState("");
  const [inviteUserPrice, setInviteUserPrice] = useState("");
  const [acceptPolicy, setAcceptPolicy] = useState(false);
  const [rows, setRows] = useState<
    { email: string; name: string; amount: string; avatar?: string }[]
  >([]);
  const [paymentForUser, setPaymentForUser] = useState("");
  const [notes, setNotes] = useState("");
  const [membershipType, setMembershipType] = useState();
  const [offerData, setOfferData] = useState<Offer | null>(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [partnerId, setPartnerId] = useState("");
  const [userPrices, setUserPrices] = useState<{ [email: string]: string }>({});
  const [selectedPaidUsers, setSelectedPaidUsers] = useState<
    { name: string; email: string; amount: number }[]
  >([]);

  const queryParams = new URLSearchParams(location.search);
  const offerType = queryParams.get("offerType");
  const handleTypeChange = (event: SelectChangeEvent) => {
    setIsAdvanceBooking(false);
    setError(false);
    setType(event.target.value);
    setSelectedOffer("");
  };
  const handleTypeChange3 = (event: SelectChangeEvent) => {
    setSelectedPaidUsers([]);
    setType1(event.target.value);
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }], // <-- Text & background color
      ["link", "image"],
      ["clean"], // remove formatting
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "link",
    "image",
  ];

  const goBack = () => {
    navigate(-1);
  };

  const handleChangePreviousOffer = (event: SelectChangeEvent) => {
    const { value } = event.target;
    setSelectedOffer(value);
    getCancelledOfferMembers(value);
  };

  const handleChangePlan = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value as string[];
    setSelectedPlan(value);
  };

  const handleChangePartnerPlan = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value as string[];
    setSelectedPartnerPlan(value);
  };

  const [guest, setGuest] = useState({
    name: "",
    email: "",
    payer: "",
    guestDietaries: [] as string[], // now an array
  });

  const handleDelete = (index: number) => {
    setGuestData((prev: any) =>
      prev?.filter((_: any, i: number) => i !== index)
    );
  };

  const [guestData, setGuestData] = useState<any[]>([]);
  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === "guestDietaries") {
      setGuest((prev) => ({
        ...prev,
        [name]: typeof value === "string" ? value.split(",") : value,
      }));
    } else {
      setGuest((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleAddGuest = () => {
    if (!guest.name || !guest.email || !guest.payer) {
      showError("Please fill all required fields");
      return;
    }

    const newGuest = {
      name: guest.name,
      email: guest.email,
      payer: guest.payer,
      guestDietaries: guest?.guestDietaries.map((d) => ({ name: d })),
    };

    setGuestData((prev) => [...prev, newGuest]);

    // reset form
    setGuest({
      name: "",
      email: "",
      payer: "",
      guestDietaries: [],
    });
  };

  const updateAnswer = (questionId: number, update: Partial<Answer>) => {
    setAnswers((prev) => {
      const existing = prev?.find((a) => a?.questionId === questionId);
      if (existing) {
        return prev?.map((a) =>
          a?.questionId === questionId ? { ...a, ...update } : a
        );
      } else {
        return [
          ...prev,
          {
            questionId,
            textValue: "",
            selectedOptionId: 0,
            selectedOptionIds: [],
            numberValue: 0,
            ...update,
          },
        ];
      }
    });
  };

  const renderField = (q: Question) => {
    const current = answers?.find((a) => a?.questionId === q?.id);

    switch (q?.inputType) {
      case "Checkbox":
        return (
          <div className="control_group w_100 prfrnc">
            <FormGroup>
              {q?.options.map((opt) => (
                <FormControlLabel
                  key={opt?.id}
                  control={
                    <Checkbox
                      checked={
                        current?.selectedOptionIds?.includes(opt?.id) || false
                      }
                      onChange={(e) => {
                        const updated = current?.selectedOptionIds || [];
                        updateAnswer(q?.id, {
                          selectedOptionIds: e.target.checked
                            ? [...updated, opt?.id]
                            : updated?.filter((id) => id !== opt?.id),
                        });
                      }}
                    />
                  }
                  label={opt?.optionText}
                />
              ))}
            </FormGroup>
          </div>
        );

      case "Radio":
        return (
          <div className="control_group w_100 prfrnc">
            <RadioGroup
              value={current?.selectedOptionId || ""}
              onChange={(e) =>
                updateAnswer(q?.id, {
                  selectedOptionId: Number(e.target.value),
                })
              }
            >
              {q.options.map((opt) => (
                <FormControlLabel
                  key={opt?.id}
                  value={opt?.id}
                  control={<Radio />}
                  label={opt?.optionText}
                />
              ))}
            </RadioGroup>
          </div>
        );

      case "Text":
        return (
          <div className="control_group w_33">
            <TextField
              variant="outlined"
              fullWidth
              placeholder={q.label}
              hiddenLabel
              value={current?.textValue || ""}
              onChange={(e) =>
                updateAnswer(q.id, { textValue: e.target.value })
              }
            />
          </div>
        );

      case "TextArea":
        return (
          <div className="control_group w_33">
            <TextField
              fullWidth
              multiline
              hiddenLabel
              rows={4}
              placeholder={q.label}
              value={current?.textValue || ""}
              onChange={(e) =>
                updateAnswer(q.id, { textValue: e.target.value })
              }
            />
          </div>
        );

      case "Date":
        return (
          // <TextField
          //   type="date"
          //   fullWidth
          //   size="small"
          //   value={current?.textValue || dayjs().format("YYYY-MM-DD")}
          //   onChange={(e) => updateAnswer(q.id, { textValue: e.target.value })}
          // />

          <div className="w_33 control_group date_field">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className="form_control"
                value={current?.textValue ? dayjs(current.textValue) : null}
                // Convert picked Dayjs -> string before saving
                onChange={(newValue: Dayjs | null) =>
                  updateAnswer(q.id, {
                    textValue: newValue ? newValue.toISOString() : "",
                  })
                }
                minDate={dayjs()}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    placeholder: "End Date",
                    sx: {
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#9999", // change text & placeholder color
                        opacity: 1,
                      },
                    },
                  },
                }}
                slots={{
                  openPickerIcon: () => (
                    <img src="/static/images/calendar_icon.svg" alt="icon" />
                  ),
                }}
                desktopModeMediaQuery="(min-width:0px)"
              />
            </LocalizationProvider>
          </div>
        );

      default:
        return null;
    }
  };

  const validateQuestions = () => {
    let valid = true;
    const newErrors: Record<number, string> = {}; // { questionId: "Error message" }

    questions.forEach((q: any) => {
      const ans = answers?.find((a) => a.questionId === q?.id);

      switch (q?.inputType) {
        case "Checkbox":
          if (!ans?.selectedOptionIds || ans?.selectedOptionIds?.length === 0) {
            newErrors[q?.id] = "This question is required";
            valid = false;
          }
          break;
        case "Radio":
          if (!ans?.selectedOptionId) {
            newErrors[q?.id] = "This question is required";
            valid = false;
          }
          break;
        case "Text":
        case "TextArea":
          if (!ans?.textValue?.trim()) {
            newErrors[q?.id] = "This question is required";
            valid = false;
          }
          break;
        case "Date":
          if (!ans?.textValue) {
            newErrors[q.id] = "This question is required";
            valid = false;
          }
          break;
      }
    });

    return valid;
  };

  const addUserApi = async () => {
    setError(true);

    if (!selectedEmail || !name || !selectedPlan || !guests || !date || !time) {
      return;
    }

    if (Number(guests) < 1) {
      return;
    }

    // Validate dynamic questions
    if (!validateQuestions()) {
      showError("Please answer all required questions");
      return;
    }

    if (isCancellationPolicy && !acceptPolicy) {
      showError("Please accept the cancellation policy");
      return;
    }

    const body = {
      bookingType: "Dining",
      offerId: offerId,
      bookingByUserId: userData?.id,
      email: selectedEmail,
      name: name,
      numberOfGuest: guests,
      bookingDate: dayjs(time).toISOString(),
      bookingTime: dayjs(time).format("HH:mm:ss"),
      isCancellationPolicy: isCancellationPolicy,
      dietaryRequirements: selectedPlan?.map((name) => ({ name })),
      answers: answers,
    };

    try {
      const response = await addUser(body).unwrap();
      if (response.status === 200) {
        showToast(response?.message || "");
        goBack();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const addUserForEventApi = async () => {
    setError(true);

    if (!selectedEmail || !name || !selectedPlan) {
      return;
    }

    if (
      isPartnerIncluded &&
      (!partnerEmail || !partnerName || !selectedPartnerPlan)
    ) {
      return;
    }

    if (isGuestIncluded && !guestData?.length) {
      showError("Please add guests");
      return;
    }

    // Validate dynamic questions
    if (!validateQuestions()) {
      showError("Please answer all required questions");
      return;
    }

    if (isCancellationPolicy && !acceptPolicy) {
      showError("Please accept the cancellation policy");
      return;
    }

    const body = {
      bookingType: "CreateBooking",
      offerId: offerId,
      bookingCreatedBy: userData?.id,
      name: name,
      email: selectedEmail,
      isPartnerAdded: isPartnerIncluded,
      isGuestAdded: isGuestIncluded,
      specialRequest: specialRequest,
      partnerDetails: {
        name: partnerName,
        email: partnerEmail,
        partnerDietary: selectedPartnerPlan?.map((name) => ({ name })),
      },
      userDietaryRequests: selectedPlan?.map((name) => ({ name })),
      offerGuestInviteds: guestData,
      answers: answers,
    };

    try {
      const response = await addUserForEvent(body).unwrap();
      if (response.status === 200) {
        showToast(response?.message || "");
        goBack();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const addUserForDealerApi = async () => {
    setError(true);

    if (
      !selectedEmail ||
      !name ||
      !selectedPlan ||
      !specialRequest ||
      !paymentForUser
    ) {
      return;
    }

    // Validate dynamic questions
    if (!validateQuestions()) {
      showError("Please answer all required questions");
      return;
    }

    if (isCancellationPolicy && !acceptPolicy) {
      showError("Please accept the cancellation policy");
      return;
    }

    const body = {
      bookingType: "ContactDealer",
      offerId: offerId,
      bookingByUserId: userData?.id,
      email: selectedEmail,
      name: name,
      contactDealerNotes: notes,
      contactDealerAmount: paymentForUser,
      dietaryRequirements: selectedPlan?.map((name) => ({ name })),
      answers: answers,
    };

    try {
      const response = await addUser(body).unwrap();
      if (response.status === 200) {
        showToast(response?.message || "");
        goBack();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const addUserForOtherApi = async () => {
    setError(true);

    if (!selectedEmail || !name || !selectedPlan) {
      return;
    }

    if (isGuestIncluded && !guestData?.length) {
      showError("Please add guests");
      return;
    }

    // Validate dynamic questions
    if (!validateQuestions()) {
      showError("Please answer all required questions");
      return;
    }

    if (isCancellationPolicy && !acceptPolicy) {
      showError("Please accept the cancellation policy");
      return;
    }

    const body = {
      bookingType: "Other",
      offerId: offerId,
      bookingCreatedBy: userData?.id,
      name: name,
      email: selectedEmail,
      isPartnerAdded: false,
      isGuestAdded: isGuestIncluded,
      userDietaryRequests: selectedPlan?.map((name) => ({ name })),
      answers: answers,
      ...(isdiningforOther && isGuestAdded
        ? { numberofGuest: Number(guests) }
        : {}),
      ...(!isdiningforOther && isGuestAdded
        ? { offerGuestInviteds: guestData }
        : {}),
    };

    try {
      const response = await addUserForEvent(body).unwrap();
      if (response.status === 200) {
        showToast(response?.message || "");
        goBack();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleCheckboxChange = (user: any) => {
    setSelectedUsers((prevSelected) => {
      const exists = prevSelected?.some((u) => u?.email === user?.email);
      if (exists) {
        // Remove if already selected
        return prevSelected?.filter((u) => u?.email !== user?.email);
      } else {
        // Add new user
        return [
          ...prevSelected,
          {
            name: user?.name,
            email: user?.email,
            roles: user?.roles ?? "User",
          },
        ];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedUsers.length === users.length) {
      // Deselect all
      setSelectedUsers([]);
    } else {
      // Select all
      const allFormatted = users.map((u: any) => ({
        name: u.name,
        email: u.email,
        roles: u.roles ?? "User",
      }));
      setSelectedUsers(allFormatted);
    }
  };

  const handleSelectAllPaid = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      // select all
      const allSelected = users.map((row: any) => ({
        name: row.name || "-",
        email: row.email,
        amount: Number(userPrices[row?.email] || inviteUserPrice || 0),
      }));
      setSelectedPaidUsers(allSelected);
    } else {
      // unselect all
      setSelectedPaidUsers([]);
    }
  };

  const isAllSelected = selectedUsers?.length === users?.length;
  const isAllSelectedPaid = selectedPaidUsers?.length === users?.length;

  const addComplimentaryApi = async () => {
    setLoading(true);
    try {
      const body = {
        currentOfferId: offerId,
        bookingType: "Complimentary",
        // forAllUser: "string",
        ...(selectedOffer ? { compensateOfferId: selectedOffer } : {}),
        userDetails: selectedUsers,
        answers: null,
      };

      const response = await complimentaryBooking(body).unwrap();

      setLoading(false);

      if (response.status === 200) {
        setSelectedUsers([]);
        showToast(response?.message || "");
        goBack();
      }
    } catch (error: any) {
      setLoading(false);
    }
  };

  const addPaidApi = async () => {
    setLoading(true);
    try {
      const body = {
        currentOfferId: offerId,
        ...(selectedOffer ? { compensateOfferId: selectedOffer } : {}),
        bookingType: "Paid",
        amount: inviteUserPrice,
        PaidUserDetails: selectedPaidUsers,
        answers: null,
      };

      const response = await addPaidBooking(body).unwrap();

      setLoading(false);

      if (response.status === 200) {
        setSelectedUsers([]);
        showToast(response?.message || "");
        goBack();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
    }
  };

  const handleAddUserToTable = () => {
    setError(true);
    if (!selectedEmail || !inviteUserName || !inviteUserPrice) {
      return;
    }

    const newRow = {
      email: selectedEmail,
      name: inviteUserName,
      amount: inviteUserPrice, // convert to number
    };

    setRows((prev) => [...prev, newRow]);

    // Reset inputs
    setSelectedEmail(null);
    setInviteUserName("");
    setInviteUserPrice("");
    setError(false);
  };

  const handleDeleteInviteUserData = (index: number) => {
    setRows((prev) => prev.filter((_, i) => i !== index));
  };

  const addInviteUserApi = async () => {
    if (!rows?.length) {
      showError("Please add users");
      return;
    }

    setLoading(true);
    try {
      const body = {
        offerId: offerId,
        bookingType: "SendInvite",
        inviteUserDetails: rows,
        answers: null,
      };

      const response = await inviteBooking(body).unwrap();

      setLoading(false);

      if (response.status === 200) {
        setRows([]);
        showToast(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
    }
  };

  const getUsersApi = async () => {
    setLoading(true);
    try {
      const response = await getUsers({
        search: debouncedSearchTerm?.trim(),
      }).unwrap();

      setLoading(false);

      if (response.status === 200) {
        const activeUsers = response?.data?.filter(
          (user: any) => user?.isActive === true
        );
        setUsers(activeUsers || []);
      } else {
        setUsers([]);
      }
    } catch (error: any) {
      setLoading(false);
    }
  };

  const getCancelledOffers = async () => {
    try {
      const response = await cancelledOffers({
        search: debouncedSearchTerm?.trim(),
      }).unwrap();

      if (response.status === 200) {
        setPreviousOffers(response?.data || []);
      } else {
        setPreviousOffers([]);
      }
    } catch (error: any) {}
  };

  const getUserByEmail = async (email: string) => {
    try {
      setLoading(true);
      const response = await userByEmail({
        email,
      }).unwrap();
      setLoading(false);

      if (response.status === 200) {
        setSelectedPlan(response?.data?.dietary);

        if (response?.data?.userDetails?.membershipType === "Single") {
          setIsPartnerIncluded(false);
        }
        setMembershipType(response?.data?.userDetails?.membershipType);

        setPartnerEmail(response?.data?.partnerDetails?.email || "");
        setPartnerName(response?.data?.partnerDetails?.name || "");
        setSelectedPartnerPlan(response?.data?.partnerDietary || []);
        setPartnerId(response?.data?.partnerDetails?.id || "");
      }
    } catch (error: any) {
      setLoading(false);
    }
  };

  const getBookingMembers = async () => {
    try {
      setLoading(true);
      const response = await bookingMembers({
        offerId,
        search: debouncedSearchTerm?.trim(),
      }).unwrap();
      setLoading(false);

      if (response.status === 200) {
        setUsers(response?.data || []);
      } else {
        setUsers([]);
      }
    } catch (error: any) {
      setLoading(false);
    }
  };

  const getDietaryApi: any = async () => {
    setLoading(true);
    try {
      const response = await getDietary({
        page: 1,
        search: "",
      }).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setDietary(response?.data || []);
      } else {
        setLoading(false);
        setDietary([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getOfferDetailApi = async () => {
    try {
      setLoading(true);
      const response = await getOfferDetail({
        offerId,
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setOfferData(response?.data);
        setSelectedEmail(clientEmail || "");
        setName(clientName || "");
        getUserByEmail(clientEmail);
        setDate(bookingDate ? dayjs(bookingDate) : null);
        setTime(bookingDate ? dayjs(bookingDate) : null);
        setGuests(numberOfGuest || "1");
        setIsPartnerIncluded(isPartnerAdded || false);
        setSpecialRequest(specialRequestState || "");
        setGuestData(
          guestDetails?.length
            ? guestDetails?.map((item: any) => ({
                name: item?.name,
                email: item?.email,
                payer: item?.payer,
                guestDietaries: item?.dietaries?.map((i: any) => ({
                  name: i?.name,
                })),
              }))
            : []
        );
        setIsGuestIncluded(isGuestAdded);
        setNotes(contactDealerNotes);
        setPaymentForUser(contactDealerAmount);
      } else {
        setLoading(false);
        setOfferData(null);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const editBookingApi = async () => {
    setError(true);
    if (
      offerType === OFFER_TYPE.EVENTS &&
      isGuestIncluded &&
      !guestData?.length
    ) {
      showError("Please add guests");
      return;
    }

    if (
      offerType === OFFER_TYPE.CONTACT_DEALERS &&
      (!specialRequest || !paymentForUser)
    ) {
      return;
    }

    if (!validateQuestions()) {
      showError("Please answer all required questions");
      return;
    }

    try {
      setLoading(true);
      const body = {
        bookingId: bookingId,
        isPartnerAdd: isPartnerIncluded,
        bookingDate: dayjs(date).toISOString(),
        bookingTime: dayjs(time).format("HH:mm:ss"),
        numberofGuest: guests,
        guestDetailsRquestModels: guestData,
        userQuestionAnswer: answers,
        ...(offerType === OFFER_TYPE.OTHERS
          ? { partnerDetails: null }
          : {
              partnerDetails: {
                id: partnerId,
                name: partnerName,
                email: partnerEmail,
                partnerDietary: selectedPartnerPlan?.map((name) => ({ name })),
              },
            }),
        ...(offerType === OFFER_TYPE.CONTACT_DEALERS
          ? { contactDealerNotes: notes }
          : {}),
        ...(offerType === OFFER_TYPE.CONTACT_DEALERS
          ? { contactDealerAmount: paymentForUser }
          : {}),
      };

      const response = await editBooking(body).unwrap();

      setLoading(false);

      if (response.status === 200) {
        showToast(response?.message || "");
        goBack();
      }
    } catch (error: any) {
      setLoading(false);
    }
  };

  const getCancelledOfferMembers = async (offerId: string) => {
    try {
      const response = await cancelledOfferMembers({
        offerId,
        search: "",
      }).unwrap();

      if (response.status === 200) {
        const formattedData = response?.data.map((item: any) => ({
          ...item,
          name: item?.user?.name,
          email: item?.user?.email,
          user: undefined,
        }));
        setUsers(formattedData || []);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getDietaryApi();
    setInviteUserPrice(price || "0");
  }, []);

  useEffect(() => {
    if (isAdvanceBooking) {
      getCancelledOffers();
    }
  }, [isAdvanceBooking]);

  useEffect(() => {
    if (offerType === OFFER_TYPE.EVENTS) {
      getBookingMembers();
    } else {
      getUsersApi();
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (isEdit) {
      getOfferDetailApi();

      if (questions?.length) {
        const ans = questions?.map((q) => ({
          questionId: q?.id,
          textValue: q?.answer?.textValue || "",
          selectedOptionId: q?.answer?.selectedOptionId || 0,
          selectedOptionIds: q?.answer?.checkboxOptions || [],
          numberValue: q?.answer?.numberValue || 0,
        }));
        setAnswers(ans);
      }

      setType("Create Booking");
    }
  }, []);

  const handlePaidCheckboxChange = (row: any) => {
    setSelectedPaidUsers((prev) => {
      const exists = prev.find((u) => u?.email === row?.email);

      if (exists) {
        // remove if unchecked
        return prev.filter((u) => u?.email !== row?.email);
      } else {
        // add if checked
        return [
          ...prev,
          {
            name: row.name || "-",
            email: row.email,
            amount: Number(userPrices[row?.email] || inviteUserPrice || 0),
          },
        ];
      }
    });
  };

  useEffect(() => {
    if (users?.length && clientEmail) {
      const found = users?.find((u) => u?.email === clientEmail) || null;
      setSelectedUser(found);
    }
  }, [users, clientEmail]);

  // initialize user prices whenever "inviteUserPrice" changes OR users list changes
  useEffect(() => {
    if (users?.length) {
      const initialPrices: { [email: string]: string } = {};
      users.forEach((u: any) => {
        initialPrices[u.email] = inviteUserPrice || ""; // prefill
      });
      setUserPrices(initialPrices);
    }
  }, [users, inviteUserPrice]);

  const handlePriceChange = (email: string, value: string) => {
    if (value === " " || value === ".") return;

    setUserPrices((prev) => ({
      ...prev,
      [email]: value,
    }));

    setSelectedUsers((prev) =>
      prev.map((u) =>
        u.email === email ? { ...u, amount: Number(value) || 0 } : u
      )
    );
  };
  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title d_flex">
        <div className="left_s">
          <h1 className="back_arrow">
            {" "}
            <IconButton onClick={() => goBack()}>
              {" "}
              <ArrowBackIcon />{" "}
            </IconButton>{" "}
            {isEdit ? "Edit Booking" : "Add User"}
          </h1>
        </div>
      </div>
      {offerType === OFFER_TYPE.EVENTS ? (
        <div className="cards add_user_link">
          <div className="">
            <div className="control_group w_100">
              <label>Type</label>
              <FormControl className="paid_radio" disabled={isEdit}>
                <RadioGroup value={type} onChange={handleTypeChange}>
                  <FormControlLabel
                    value="Complimentary"
                    control={<Radio />}
                    label="Complimentary"
                    sx={{
                      "&.Mui-disabled": {
                        color: "rgba(255,255,255,0.3)",
                      },
                      "&.Mui-disabled .MuiFormControlLabel-label": {
                        color: "rgba(255,255,255,0.3)",
                      },
                    }}
                  />
                  <FormControlLabel
                    value="Generate link"
                    control={<Radio />}
                    label="Send Invite"
                    sx={{
                      "&.Mui-disabled": {
                        color: "rgba(255,255,255,0.3)",
                      },
                      "&.Mui-disabled .MuiFormControlLabel-label": {
                        color: "rgba(255,255,255,0.3)",
                      },
                    }}
                  />
                  <FormControlLabel
                    value="Paid"
                    control={<Radio />}
                    label="Paid"
                    sx={{
                      "&.Mui-disabled": {
                        color: "rgba(255,255,255,0.3)",
                      },
                      "&.Mui-disabled .MuiFormControlLabel-label": {
                        color: "rgba(255,255,255,0.3)",
                      },
                    }}
                  />
                  <FormControlLabel
                    value="Create Booking"
                    control={<Radio />}
                    label="Create Booking"
                    sx={{
                      "&.Mui-disabled": {
                        color: "rgba(255,255,255,0.3)",
                      },
                      "&.Mui-disabled .MuiFormControlLabel-label": {
                        color: "rgba(255,255,255,0.3)",
                      },
                    }}
                  />
                </RadioGroup>
              </FormControl>
            </div>
            {/* Show this only when type is "Complimentary" */}
            {type === "Complimentary" && (
              <>
                <div className="gap_p">
                  <div className="control_group cncl_plcy w_50">
                    <label>Previous Event</label>
                    <IosSwitchMain
                      checked={isAdvanceBooking}
                      onChange={(e) => setIsAdvanceBooking(e.target.checked)}
                    />
                  </div>

                  {isAdvanceBooking && (
                    <>
                      <div className="control_group w_50">
                        <Select
                          className="dropse"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          name="type"
                          value={selectedOffer}
                          onChange={handleChangePreviousOffer}
                        >
                          <MenuItem value="" disabled>
                            Select Offer
                          </MenuItem>
                          {previousOffer?.map((item: any) => {
                            return (
                              <MenuItem value={item?.id}>{item?.name}</MenuItem>
                            );
                          })}
                        </Select>
                      </div>
                      <div className="table_header">
                        <div className="left_s">
                          <SearchBar
                            searchTerm={searchTerm}
                            placeholder="Search...."
                            setDebouncedSearchTerm={setDebouncedSearchTerm}
                            value={searchTerm}
                            onCross={() => setSearchTerm("")}
                            onChange={(val: any) => {
                              if (isValidInput(val.target.value)) {
                                setSearchTerm(val.target.value);
                              }
                            }}
                          />
                        </div>

                        <div>
                          <Button
                            className="btn btn_primary"
                            onClick={addComplimentaryApi}
                          >
                            Save
                          </Button>
                        </div>
                      </div>

                      <div className="table_container">
                        <table
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead
                            style={{
                              backgroundColor: "#C19857",
                              color: "#fff",
                              textAlign: "left",
                            }}
                          >
                            <tr>
                              <th>
                                {" "}
                                <Checkbox
                                  checked={isAllSelected}
                                  onChange={handleSelectAll}
                                />
                              </th>{" "}
                              {/* Checkbox */}
                              <th>Name</th>
                              <th>Type</th>
                            </tr>
                          </thead>
                          <tbody>
                            {users?.length ? (
                              users?.map((row, index) => (
                                <tr
                                  key={index}
                                  style={
                                    {
                                      // color: "#fff",
                                      // borderBottom: "1px solid #444",
                                    }
                                  }
                                >
                                  <td>
                                    <Checkbox
                                      checked={selectedUsers?.some(
                                        (u) => u?.email === row?.email
                                      )}
                                      onChange={() => handleCheckboxChange(row)}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <img
                                      src={
                                        "/static/images/user_placeholder.png"
                                      }
                                      alt={row?.name}
                                      style={{
                                        width: 32,
                                        height: 32,
                                        borderRadius: "50%",
                                      }}
                                    />
                                    {row?.name || "-"}
                                  </td>
                                  <td>{row?.role || "User"}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={3}>No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                  {!isAdvanceBooking && (
                    <>
                      <div className="table_header">
                        <div className="left_s">
                          <SearchBar
                            searchTerm={searchTerm}
                            placeholder="Search...."
                            setDebouncedSearchTerm={setDebouncedSearchTerm}
                            value={searchTerm}
                            onCross={() => setSearchTerm("")}
                            onChange={(val: any) => {
                              if (isValidInput(val.target.value)) {
                                setSearchTerm(val.target.value);
                              }
                            }}
                          />
                        </div>

                        <div>
                          <Button
                            className="btn btn_primary"
                            onClick={addComplimentaryApi}
                          >
                            Save
                          </Button>
                        </div>
                      </div>
                      <div className="table_container">
                        <table
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead
                            style={{
                              backgroundColor: "#C19857",
                              color: "#fff",
                              textAlign: "left",
                            }}
                          >
                            <tr>
                              <th>
                                {" "}
                                <Checkbox
                                  checked={isAllSelected}
                                  onChange={handleSelectAll}
                                />
                              </th>{" "}
                              {/* Checkbox */}
                              <th>Name</th>
                              <th>Type</th>
                            </tr>
                          </thead>
                          <tbody>
                            {users
                              ? users?.map((row, index) => (
                                  <tr
                                    key={index}
                                    style={
                                      {
                                        // color: "#fff",
                                        // borderBottom: "1px solid #444",
                                      }
                                    }
                                  >
                                    <td>
                                      <Checkbox
                                        checked={selectedUsers.some(
                                          (u) => u?.email === row?.email
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(row)
                                        }
                                      />
                                    </td>
                                    <td
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <img
                                        src={
                                          "/static/images/user_placeholder.png"
                                        }
                                        alt={row?.name}
                                        style={{
                                          width: 32,
                                          height: 32,
                                          borderRadius: "50%",
                                        }}
                                      />
                                      {row?.name || "-"}
                                    </td>
                                    <td>{row?.role || "User"}</td>
                                  </tr>
                                ))
                              : null}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
            {type === "Generate link" && (
              <>
                <div className="gap_p">
                  <div className="control_group w_50">
                    <Autocomplete
                      disablePortal
                      options={users}
                      value={{ email: selectedEmail, name: inviteUserName }}
                      getOptionLabel={(option: any) => {
                        if (!option) return "";
                        return option.email || option.name || ""; // fallback chain
                      }}
                      onChange={(event, value) => {
                        if (value) {
                          setSelectedEmail(value?.email);
                          setInviteUserName(value?.name);
                        } else {
                          setSelectedEmail(null);
                          setInviteUserName("");
                        }
                      }}
                      sx={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          value={"sss"}
                          {...params}
                          placeholder="Email Address"
                          hiddenLabel
                        />
                      )}
                    />
                    {error && !selectedEmail ? (
                      <p className="err_msg">Email is required</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="control_group w_50">
                    <TextField
                      variant="outlined"
                      placeholder="Name"
                      fullWidth
                      hiddenLabel
                      inputProps={{ maxLength: 40 }}
                      value={inviteUserName}
                      onChange={(e) => {
                        if (e.target.value === " " || e.target.value === ".") {
                        } else {
                          setInviteUserName(e.target.value);
                        }
                      }}
                    />
                    {error && !inviteUserName ? (
                      <p className="err_msg">Name is required</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="control_group w_50">
                    <TextField
                      variant="outlined"
                      placeholder="Amount"
                      fullWidth
                      hiddenLabel
                      inputProps={{ maxLength: 40 }}
                      value={inviteUserPrice}
                      onChange={(e) => {
                        if (e.target.value === " " || e.target.value === ".") {
                        } else {
                          setInviteUserPrice(e.target.value);
                        }
                      }}
                    />
                    {error && !inviteUserPrice ? (
                      <p className="err_msg">Price is required</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    className="control_group w_50"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      className="btn btn_primary"
                      onClick={handleAddUserToTable}
                    >
                      Add
                    </Button>
                  </div>

                  <div className="table_container">
                    <table
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead
                        style={{
                          backgroundColor: "#C19857",
                          color: "#fff",
                          textAlign: "left",
                        }}
                      >
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows?.length ? (
                          rows?.map((row, index) => (
                            <tr
                              key={index}
                              style={
                                {
                                  // color: "#fff",
                                  // borderBottom: "1px solid #444",
                                }
                              }
                            >
                              <td>{row.name}</td>
                              <td>{row.email}</td>
                              <td>{row.amount}</td>
                              <td>
                                {" "}
                                <IconButton
                                  onClick={() =>
                                    handleDeleteInviteUserData(index)
                                  }
                                >
                                  <img
                                    src="/static/images/trash2_icon.svg"
                                    alt="Delete"
                                  />
                                </IconButton>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={4}
                              style={{ textAlign: "center", padding: "20px" }}
                            >
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="mt_30">
                    <Button
                      className="btn btn_primary"
                      onClick={addInviteUserApi}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </>
            )}
            {type === "Paid" && (
              <>
                <div className="gap_p">
                  <div className="control_group cncl_plcy w_50">
                    <label>Previous Event</label>
                    <IosSwitchMain
                      checked={isAdvanceBooking}
                      onChange={(e) => {
                        if (!e.target.checked) {
                          getBookingMembers();
                          setSelectedOffer("");
                        }
                        setIsAdvanceBooking(e.target.checked);
                      }}
                    />
                  </div>
                  <>
                    {isAdvanceBooking ? (
                      <div className="control_group w_50">
                        <Select
                          className="dropse"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          name="type"
                          value={selectedOffer}
                          onChange={handleChangePreviousOffer}
                        >
                          <MenuItem value="" disabled>
                            Select Offer
                          </MenuItem>
                          {previousOffer?.map((item: any) => {
                            return (
                              <MenuItem value={item?.id}>{item?.name}</MenuItem>
                            );
                          })}
                        </Select>
                      </div>
                    ) : null}

                    <div className="control_group w_100">
                      <label>Same amount for all</label>
                      <FormControl className="paid_radio">
                        <RadioGroup value={type1} onChange={handleTypeChange3}>
                          <FormControlLabel
                            value="Yes"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio />}
                            label="No"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                    {type1 === "Yes" && (
                      <>
                        <div className="control_group w_50">
                          <TextField
                            variant="outlined"
                            placeholder="Amount"
                            fullWidth
                            hiddenLabel
                            inputProps={{ maxLength: 40 }}
                            value={inviteUserPrice}
                            onChange={(e) => {
                              if (
                                e.target.value === " " ||
                                e.target.value === "."
                              ) {
                              } else {
                                setInviteUserPrice(e.target.value);
                              }
                            }}
                          />
                        </div>
                        <div className="table_header">
                          <div className="left_s">
                            <SearchBar
                              searchTerm={searchTerm}
                              placeholder="Search...."
                              setDebouncedSearchTerm={setDebouncedSearchTerm}
                              value={searchTerm}
                              onCross={() => setSearchTerm("")}
                              onChange={(val: any) => {
                                if (isValidInput(val.target.value)) {
                                  setSearchTerm(val.target.value);
                                }
                              }}
                            />
                          </div>
                          <div className="mt_30">
                            <Button
                              className="btn btn_primary"
                              onClick={addPaidApi}
                            >
                              Add
                            </Button>
                          </div>
                        </div>
                        <div className="table_container">
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                            }}
                          >
                            <thead
                              style={{
                                backgroundColor: "#C19857",
                                color: "#fff",
                                textAlign: "left",
                              }}
                            >
                              <tr>
                                <th>
                                  {" "}
                                  <Checkbox
                                    checked={isAllSelectedPaid}
                                    onChange={handleSelectAllPaid}
                                  />
                                </th>{" "}
                                {/* Checkbox */}
                                <th>Name</th>
                                <th>Type</th>
                              </tr>
                            </thead>
                            <tbody>
                              {users?.length ? (
                                users?.map((row, index) => (
                                  <tr
                                    key={index}
                                    style={
                                      {
                                        // color: "#fff",
                                        // borderBottom: "1px solid #444",
                                      }
                                    }
                                  >
                                    <td>
                                      <Checkbox
                                        checked={selectedPaidUsers?.some(
                                          (u) => u?.email === row?.email
                                        )}
                                        onChange={() =>
                                          handlePaidCheckboxChange(row)
                                        }
                                      />
                                    </td>
                                    <td
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <img
                                        src={
                                          "/static/images/user_placeholder.png"
                                        }
                                        alt={row?.name}
                                        style={{
                                          width: 32,
                                          height: 32,
                                          borderRadius: "50%",
                                        }}
                                      />
                                      {row?.name || "-"}
                                    </td>
                                    <td>{row?.role || "User"}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={3}>No Data Found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                    {type1 === "No" && (
                      <>
                        <div className="table_header">
                          <div className="left_s">
                            <SearchBar
                              searchTerm={searchTerm}
                              placeholder="Search...."
                              setDebouncedSearchTerm={setDebouncedSearchTerm}
                              value={searchTerm}
                              onCross={() => setSearchTerm("")}
                              onChange={(val: any) => {
                                if (isValidInput(val.target.value)) {
                                  setSearchTerm(val.target.value);
                                }
                              }}
                            />
                          </div>
                          <div className="mt_30">
                            <Button
                              className="btn btn_primary"
                              onClick={addPaidApi}
                            >
                              Add
                            </Button>
                          </div>
                        </div>
                        <div className="table_container">
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                            }}
                          >
                            <thead
                              style={{
                                backgroundColor: "#C19857",
                                color: "#fff",
                                textAlign: "left",
                              }}
                            >
                              <tr>
                                <th>
                                  {" "}
                                  <Checkbox
                                    checked={isAllSelectedPaid}
                                    onChange={handleSelectAllPaid}
                                  />
                                </th>{" "}
                                {/* Checkbox */}
                                <th>Name</th>
                                <th>Type</th>
                                <th>Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {users?.length ? (
                                users?.map((row, index) => (
                                  <tr
                                    key={index}
                                    style={
                                      {
                                        // color: "#fff",
                                        // borderBottom: "1px solid #444",
                                      }
                                    }
                                  >
                                    <td>
                                      <Checkbox
                                        checked={selectedPaidUsers?.some(
                                          (u) => u?.email === row?.email
                                        )}
                                        onChange={() =>
                                          handlePaidCheckboxChange(row)
                                        }
                                      />
                                    </td>
                                    <td>
                                      <div className="user_block click_action">
                                        <img
                                          src={
                                            "/static/images/user_placeholder.png"
                                          }
                                          alt={row?.name}
                                          style={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: "50%",
                                          }}
                                        />
                                        {row?.name || "-"}
                                      </div>
                                    </td>
                                    <td>{row?.role || "User"}</td>
                                    <td style={{ width: "150px" }}>
                                      <TextField
                                        variant="outlined"
                                        placeholder="Amount"
                                        fullWidth
                                        hiddenLabel
                                        inputProps={{ maxLength: 40 }}
                                        value={userPrices[row.email] || ""}
                                        onChange={(e) =>
                                          handlePriceChange(
                                            row.email,
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={3}>No Data Found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                  </>
                </div>
              </>
            )}
            {type === "Create Booking" && (
              <div className="gap_p">
                <div className="control_group w_33">
                  {isEdit ? (
                    <TextField
                      variant="outlined"
                      placeholder="Email"
                      fullWidth
                      hiddenLabel
                      inputProps={{ maxLength: 40 }}
                      value={selectedEmail}
                      disabled
                    />
                  ) : (
                    <>
                      <Autocomplete
                        disablePortal
                        value={selectedUser}
                        options={users}
                        getOptionLabel={(option) => option?.email}
                        onChange={(event, value) => {
                          setSelectedUser(value);
                          if (value) {
                            setSelectedEmail(value?.email);
                            setName(value?.name);
                            getUserByEmail(value?.email);
                          } else {
                            setSelectedEmail(null);
                            setName("");
                          }
                        }}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Email Address"
                            hiddenLabel
                          />
                        )}
                      />
                      {error && !selectedEmail ? (
                        <p className="err_msg">Email is required</p>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </div>
                <div className="control_group w_33">
                  <TextField
                    variant="outlined"
                    placeholder="Name"
                    fullWidth
                    hiddenLabel
                    disabled={isEdit}
                    inputProps={{ maxLength: 40 }}
                    value={name}
                    onChange={(e) => {
                      if (e.target.value === " " || e.target.value === ".") {
                      } else {
                        setName(e.target.value);
                      }
                    }}
                  />
                  {error && !name ? (
                    <p className="err_msg">Name is required</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="form_group w_33">
                  <Select
                    multiple
                    value={selectedPlan}
                    name="page"
                    disabled={isEdit}
                    onChange={handleChangePlan}
                    displayEmpty
                    renderValue={(selected: any) =>
                      selected?.length === 0
                        ? "Select Dietary Requirements"
                        : selected?.join(", ")
                    }
                  >
                    <MenuItem value="" disabled>
                      Select Dietary Requirements
                    </MenuItem>
                    {dietary?.map((item: any, index: number) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                  {error && !selectedPlan?.length ? (
                    <p className="err_msg">Dietary Requirements is required</p>
                  ) : (
                    ""
                  )}
                </div>

                <div className="control_group w_33">
                  <TextField
                    variant="outlined"
                    placeholder="Any special request or occasion?"
                    fullWidth
                    hiddenLabel
                    disabled={isEdit}
                    inputProps={{ maxLength: 150 }}
                    value={specialRequest}
                    onChange={(e) => {
                      if (e.target.value === " " || e.target.value === ".") {
                      } else {
                        setSpecialRequest(e.target.value);
                      }
                    }}
                  />
                </div>
                <div className="control_group w_33" />

                <div className="control_group cncl_plcy w_50">
                  <label>Include Partner</label>
                  <IosSwitchMain
                    checked={isPartnerIncluded}
                    onChange={(e) => setIsPartnerIncluded(e.target.checked)}
                    disabled={membershipType === "Single" || isPartnerAdded}
                  />
                </div>
                {isPartnerIncluded && (
                  <>
                    <div className="gap_p">
                      <div className="control_group w_33">
                        <TextField
                          variant="outlined"
                          placeholder="Email"
                          fullWidth
                          hiddenLabel
                          disabled
                          inputProps={{ maxLength: 40 }}
                          value={partnerEmail}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\s/g, "");
                            setPartnerEmail(value);
                          }}
                          InputProps={{
                            sx: {
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#ffffff", // your custom color
                              },
                            },
                          }}
                        />
                        {error && !partnerEmail ? (
                          <p className="err_msg">Email is required</p>
                        ) : error && !isValidEmail(partnerEmail) ? (
                          <p className="err_msg">Please enter a valid email</p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="control_group w_33">
                        <TextField
                          variant="outlined"
                          placeholder="Name"
                          fullWidth
                          hiddenLabel
                          inputProps={{ maxLength: 40 }}
                          disabled
                          value={partnerName}
                          InputProps={{
                            sx: {
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "#ffffff", // your custom color
                              },
                            },
                          }}
                          onChange={(e) => {
                            if (
                              e.target.value === " " ||
                              e.target.value === "."
                            ) {
                            } else {
                              setPartnerName(e.target.value);
                            }
                          }}
                        />
                        {error && !partnerName ? (
                          <p className="err_msg">Name is required</p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="form_group w_33">
                        <Select
                          multiple
                          value={selectedPartnerPlan}
                          name="page"
                          disabled={isEdit}
                          onChange={handleChangePartnerPlan}
                          displayEmpty
                          renderValue={(selected: any) =>
                            selected?.length === 0
                              ? "Select Dietary Requirements"
                              : selected?.join(", ")
                          }
                        >
                          <MenuItem value="" disabled>
                            Select Dietary Requirements
                          </MenuItem>
                          {dietary?.map((item: any, index: number) => (
                            <MenuItem key={index} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                        {error && !selectedPartnerPlan?.length ? (
                          <p className="err_msg">
                            Dietary Requirements is required
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </>
                )}
                <div className="control_group cncl_plcy w_50">
                  <label>Include Guest</label>
                  <IosSwitchMain
                    checked={isGuestIncluded}
                    onChange={(e) => {
                      setGuestData([]);
                      setIsGuestIncluded(e.target.checked);
                    }}
                    disabled={!isGuestAdded}
                  />
                </div>
                {isGuestIncluded && (
                  <>
                    <div className="gap_p">
                      <div className="control_group w_33">
                        <TextField
                          variant="outlined"
                          placeholder="Email"
                          fullWidth
                          hiddenLabel
                          name="email"
                          value={guest.email}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="control_group w_33">
                        <TextField
                          variant="outlined"
                          placeholder="Name"
                          fullWidth
                          hiddenLabel
                          name="name"
                          value={guest.name}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="form_group w_33">
                        <Select
                          multiple
                          value={guest.guestDietaries}
                          name="guestDietaries"
                          onChange={handleChange}
                          displayEmpty
                          renderValue={(selected: any) =>
                            selected?.length === 0
                              ? "Select Dietary Requirements"
                              : selected?.join(", ")
                          }
                        >
                          <MenuItem value="" disabled>
                            Select Dietary Requirements
                          </MenuItem>
                          {dietary?.map((item: any, index: number) => (
                            <MenuItem key={index} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      <div className="control_group w_50">
                        <Select
                          className="dropse"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          name="payer"
                          value={guest.payer}
                          onChange={handleChange}
                        >
                          <MenuItem value="" disabled>
                            Select Payer
                          </MenuItem>
                          <MenuItem value="Primary">
                            {name || "Primary"}
                          </MenuItem>
                          {isPartnerIncluded ? (
                            <MenuItem value="Secondary">
                              {partnerName || "Secondary"}
                            </MenuItem>
                          ) : null}
                        </Select>
                      </div>

                      {guestData?.length < numberOfGuest ? (
                        <div
                          className="control_group w_50"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Button
                            className="btn btn_primary"
                            onClick={handleAddGuest}
                          >
                            Save Guest
                          </Button>
                        </div>
                      ) : null}
                    </div>
                  </>
                )}

                <div className="prvs_qstn_mn">
                  <div className="d_flx1">
                    {guestData?.map((g, index) => (
                      <div
                        className="question_card"
                        style={{
                          border: "1px solid #BC8F4B",
                          borderRadius: "8px",
                          padding: 10,
                        }}
                      >
                        <Box display="flex" justifyContent="space-between">
                          <div>
                            <Typography variant="body2">
                              Name: {g?.name || "-"}
                            </Typography>
                            <Typography variant="body2">
                              Email: {g?.email || "-"}
                            </Typography>
                            <Typography variant="body2">
                              Payer: {g?.payer || "-"}
                            </Typography>
                            {g?.guestDietaries?.length > 0 && (
                              <Typography variant="body2">
                                Dietary: {g?.guestDietaries[0]?.name || "-"}
                              </Typography>
                            )}
                          </div>

                          <IconButton
                            color="error"
                            sx={{ alignSelf: "flex-start" }}
                            onClick={() => handleDelete(index)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </div>
                    ))}
                  </div>
                </div>

                {questions?.map((q: any) => (
                  <div key={q?.id} style={{ marginBottom: 20 }}>
                    <label>{q?.label}</label>

                    {renderField(q)}
                  </div>
                ))}

                {isCancellationPolicy && (
                  <div className="control_group w_100">
                    <p className="note">
                      Please note: By proceeding, you agree to our cancellation
                      policy.
                    </p>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Checkbox
                        checked={acceptPolicy}
                        onChange={(e) => setAcceptPolicy(e.target.checked)}
                      />
                      <label style={{ marginTop: "18px" }}>
                        I accept the cancellation policy
                      </label>
                    </div>
                  </div>
                )}

                <div className="mt_30">
                  <Button
                    className="btn btn_primary"
                    onClick={() => {
                      isEdit ? editBookingApi() : addUserForEventApi();
                    }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : offerType === OFFER_TYPE.OTHERS ? (
        <div className="gap_p">
          <div className="control_group w_33">
            <Autocomplete
              disablePortal
              options={users}
              value={selectedUser}
              disabled={isEdit}
              getOptionLabel={(option) => option?.email} // show email in dropdown
              onChange={(event, value) => {
                setSelectedUser(value);
                if (value) {
                  setSelectedEmail(value?.email);
                  setName(value?.name);
                } else {
                  setSelectedEmail(null);
                  setName("");
                }
              }}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Email Address"
                  hiddenLabel
                />
              )}
            />
            {error && !selectedEmail ? (
              <p className="err_msg">Email is required</p>
            ) : (
              ""
            )}
          </div>
          <div className="control_group w_33">
            <TextField
              variant="outlined"
              placeholder="Name"
              fullWidth
              hiddenLabel
              disabled={isEdit}
              inputProps={{ maxLength: 40 }}
              value={name}
              onChange={(e) => {
                if (e.target.value === " " || e.target.value === ".") {
                } else {
                  setName(e.target.value);
                }
              }}
            />
            {error && !name ? <p className="err_msg">Name is required</p> : ""}
          </div>
          <div className="form_group w_33">
            <Select
              multiple
              value={selectedPlan}
              name="page"
              disabled={isEdit}
              onChange={handleChangePlan}
              displayEmpty
              renderValue={(selected: any) =>
                selected?.length === 0
                  ? "Select Dietary Requirements"
                  : selected?.join(", ")
              }
            >
              <MenuItem value="" disabled>
                Select Dietary Requirements
              </MenuItem>
              {dietary?.map((item: any, index: number) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
            {error && !selectedPlan?.length ? (
              <p className="err_msg">Dietary Requirements is required</p>
            ) : (
              ""
            )}
          </div>

          {isGuestAdded && isdiningforOther ? (
            <div className="control_group w_33">
              <TextField
                variant="outlined"
                placeholder="No. of Guests"
                fullWidth
                hiddenLabel
                disabled={isEdit}
                inputProps={{ maxLength: 40 }}
                // InputProps={{ readOnly: true }}
                value={guests}
                onChange={(e) => {
                  if (e.target.value === " " || e.target.value === ".") {
                  } else {
                    setGuests(e.target.value);
                  }
                }}
              />
              {error && !guests ? (
                <p className="err_msg">Guests is required</p>
              ) : (
                ""
              )}
            </div>
          ) : (
            <div className="control_group cncl_plcy w_50">
              <label>Include Guest</label>
              <IosSwitchMain
                checked={isGuestIncluded}
                onChange={(e) => setIsGuestIncluded(e.target.checked)}
              />
            </div>
          )}

          {isGuestIncluded && (
            <>
              <div className="gap_p">
                <div className="control_group w_33">
                  <TextField
                    variant="outlined"
                    placeholder="Email"
                    fullWidth
                    hiddenLabel
                    name="email"
                    value={guest.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="control_group w_33">
                  <TextField
                    variant="outlined"
                    placeholder="Name"
                    fullWidth
                    hiddenLabel
                    name="name"
                    value={guest.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="form_group w_33">
                  <Select
                    multiple
                    value={guest.guestDietaries}
                    name="guestDietaries"
                    onChange={handleChange}
                    displayEmpty
                    renderValue={(selected: any) =>
                      selected?.length === 0
                        ? "Select Dietary Requirements"
                        : selected?.join(", ")
                    }
                  >
                    <MenuItem value="" disabled>
                      Select Dietary Requirements
                    </MenuItem>
                    {dietary?.map((item: any, index: number) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div className="control_group w_50">
                  <Select
                    className="dropse"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    name="payer"
                    value={guest.payer}
                    onChange={handleChange}
                  >
                    <MenuItem value="" disabled>
                      Select Payer
                    </MenuItem>
                    <MenuItem value="Primary">Primary</MenuItem>
                    <MenuItem value="Secondary">Secondary</MenuItem>
                  </Select>
                </div>

                {guestData?.length < numberOfGuest ? (
                  <div
                    className="control_group w_50"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      className="btn btn_primary"
                      onClick={handleAddGuest}
                    >
                      Save Guest
                    </Button>
                  </div>
                ) : null}
              </div>
            </>
          )}

          <div className="prvs_qstn_mn">
            <div className="d_flx1">
              {guestData?.map((g, index) => (
                <div
                  className="question_card"
                  style={{
                    border: "1px solid #BC8F4B",
                    borderRadius: "8px",
                    padding: 10,
                  }}
                >
                  <Box display="flex" justifyContent="space-between">
                    <div>
                      <Typography variant="body2">Name: {g.name}</Typography>
                      <Typography variant="body2">Email: {g.email}</Typography>
                      <Typography variant="body2">Payer: {g.payer}</Typography>
                      {g.guestDietaries.length > 0 && (
                        <Typography variant="body2">
                          Dietary: {g.guestDietaries[0].name}
                        </Typography>
                      )}
                    </div>

                    <IconButton
                      color="error"
                      sx={{ alignSelf: "flex-start" }}
                      onClick={() => handleDelete(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </div>
              ))}
            </div>
          </div>

          {questions?.map((q: any) => (
            <div key={q?.id} style={{ marginBottom: 20 }}>
              <label>{q?.label}</label>

              {renderField(q)}
            </div>
          ))}

          {isCancellationPolicy && (
            <div className="control_group w_100">
              <p className="note">
                Please note: By proceeding, you agree to our cancellation
                policy.
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <Checkbox
                  checked={acceptPolicy}
                  onChange={(e) => setAcceptPolicy(e.target.checked)}
                />
                <label style={{ marginTop: "18px" }}>
                  I accept the cancellation policy
                </label>
              </div>
            </div>
          )}

          <div className="mt_30">
            <Button
              className="btn btn_primary"
              onClick={() => {
                isEdit ? editBookingApi() : addUserForOtherApi();
              }}
            >
              Save
            </Button>
          </div>
        </div>
      ) : offerType === OFFER_TYPE.CONTACT_DEALERS ? (
        <div className="cards add_user_link">
          <div className="gap_p">
            <div className="control_group w_33">
              <Autocomplete
                disablePortal
                options={users}
                value={selectedUser}
                disabled={isEdit}
                getOptionLabel={(option) => option?.email} // show email in dropdown
                onChange={(event, value) => {
                  setSelectedUser(value);
                  if (value) {
                    setSelectedEmail(value?.email);
                    setName(value?.name);
                  } else {
                    setSelectedEmail(null);
                    setName("");
                  }
                }}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Email Address"
                    hiddenLabel
                  />
                )}
              />
              {error && !selectedEmail ? (
                <p className="err_msg">Email is required</p>
              ) : (
                ""
              )}
            </div>
            <div className="control_group w_33">
              <TextField
                variant="outlined"
                placeholder="Name"
                fullWidth
                hiddenLabel
                disabled={isEdit}
                inputProps={{ maxLength: 40 }}
                value={name}
                onChange={(e) => {
                  if (e.target.value === " " || e.target.value === ".") {
                  } else {
                    setName(e.target.value);
                  }
                }}
              />
              {error && !name ? (
                <p className="err_msg">Name is required</p>
              ) : (
                ""
              )}
            </div>
            <div className="form_group w_33">
              <Select
                multiple
                value={selectedPlan}
                name="page"
                onChange={handleChangePlan}
                disabled={isEdit}
                displayEmpty
                renderValue={(selected: any) =>
                  selected?.length === 0
                    ? "Select Dietary Requirements"
                    : selected?.join(", ")
                }
              >
                <MenuItem value="" disabled>
                  Select Dietary Requirements
                </MenuItem>
                {dietary?.map((item: any, index: number) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
              {error && !selectedPlan?.length ? (
                <p className="err_msg">Dietary Requirements is required</p>
              ) : (
                ""
              )}
            </div>
            <div className="control_group w_33">
              <TextField
                variant="outlined"
                placeholder="Any special request or occasion?"
                fullWidth
                hiddenLabel
                inputProps={{ maxLength: 150 }}
                value={specialRequest}
                onChange={(e) => {
                  if (e.target.value === " " || e.target.value === ".") {
                  } else {
                    setSpecialRequest(e.target.value);
                  }
                }}
              />
              {error && !specialRequest ? (
                <p className="err_msg">Special request is required</p>
              ) : (
                ""
              )}
            </div>

            <div className="control_group w_33">
              <TextField
                variant="outlined"
                placeholder="Payment for user(amount)"
                fullWidth
                hiddenLabel
                inputProps={{ maxLength: 10 }}
                value={paymentForUser}
                onChange={(e) => {
                  const { value } = e.target;
                  if (isValidNumber(value)) {
                    setPaymentForUser(value);
                  }
                }}
              />
              {error && !paymentForUser ? (
                <p className="err_msg">amount is required</p>
              ) : (
                ""
              )}
            </div>

            <div className="control_group w_50">
              <label>Additional Information</label>
              <ReactQuill
                value={notes}
                onChange={setNotes}
                theme="snow"
                modules={modules}
                formats={formats}
                style={{ height: "200px", marginBottom: "50px" }}
              />
            </div>
          </div>

          {isCancellationPolicy && (
            <div className="control_group w_100">
              <p className="note">
                Please note: By proceeding, you agree to our cancellation
                policy.
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <Checkbox
                  checked={acceptPolicy}
                  onChange={(e) => setAcceptPolicy(e.target.checked)}
                />
                <label style={{ marginTop: "18px" }}>
                  I accept the cancellation policy
                </label>
              </div>
            </div>
          )}
          <div className="mt_30">
            <Button
              className="btn btn_primary"
              onClick={() =>
                isEdit ? editBookingApi() : addUserForDealerApi()
              }
            >
              Save
            </Button>
          </div>
        </div>
      ) : (
        <div className="cards add_user_link">
          <div className="gap_p">
            <div className="control_group w_33">
              <Autocomplete
                disablePortal
                options={users}
                value={selectedUser}
                disabled={isEdit}
                getOptionLabel={(option) => option?.email} // show email in dropdown
                onChange={(event, value) => {
                  setSelectedUser(value);
                  if (value) {
                    setSelectedEmail(value?.email);
                    setName(value?.name);
                    getUserByEmail(value?.email);
                  } else {
                    setSelectedEmail(null);
                    setName("");
                  }
                }}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Email Address"
                    hiddenLabel
                  />
                )}
              />
              {error && !selectedEmail ? (
                <p className="err_msg">Email is required</p>
              ) : (
                ""
              )}
            </div>
            <div className="control_group w_33">
              <TextField
                variant="outlined"
                placeholder="Name"
                fullWidth
                hiddenLabel
                disabled={isEdit}
                inputProps={{ maxLength: 40 }}
                value={name}
                onChange={(e) => {
                  if (e.target.value === " " || e.target.value === ".") {
                  } else {
                    setName(e.target.value);
                  }
                }}
              />
              {error && !name ? (
                <p className="err_msg">Name is required</p>
              ) : (
                ""
              )}
            </div>
            <div className="form_group w_33">
              <Select
                multiple
                value={selectedPlan}
                name="page"
                onChange={handleChangePlan}
                disabled={isEdit}
                displayEmpty
                renderValue={(selected: any) =>
                  selected?.length === 0
                    ? "Select Dietary Requirements"
                    : selected?.join(", ")
                }
              >
                <MenuItem value="" disabled>
                  Select Dietary Requirements
                </MenuItem>
                {dietary?.map((item: any, index: number) => (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
              {error && !selectedPlan?.length ? (
                <p className="err_msg">Dietary Requirements is required</p>
              ) : (
                ""
              )}
            </div>
            <div className="control_group w_33">
              <TextField
                variant="outlined"
                placeholder="No. of Guests"
                fullWidth
                hiddenLabel
                inputProps={{ maxLength: 10 }}
                // InputProps={{ readOnly: true }}
                value={guests}
                onChange={(e) => {
                  const { value } = e.target;
                  if (isValidNumber(value)) {
                    setGuests(value);
                  }
                }}
              />
              {error && !guests ? (
                <p className="err_msg">Guests is required</p>
              ) : error && Number(guests) < 1 ? (
                <p className="err_msg">Minimum 1 guest is required</p>
              ) : (
                ""
              )}
            </div>
            <div className="w_33 control_group date_field">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  value={date}
                  onChange={(newValue) => setDate(newValue)}
                  minDate={dayjs()}
                  maxDate={finalMaxDate}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      placeholder: "Select Date",
                      sx: {
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "#9999", // change text & placeholder color
                          opacity: 1,
                        },
                      },
                    },
                  }}
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/calendar_icon.svg" alt="icon" />
                    ),
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
                {error && !date ? (
                  <p className="err_msg">Date is required</p>
                ) : (
                  ""
                )}
              </LocalizationProvider>
            </div>
            <div className="w_33 control_group date_field">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  value={time}
                  onChange={(newValue) => {
                    if (date) {
                      setTime(
                        dayjs(date)
                          .hour(dayjs(newValue).hour())
                          .minute(dayjs(newValue).minute())
                      );
                    }
                  }}
                  slotProps={{
                    textField: {
                      placeholder: "Select Time",
                      sx: {
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "#9999", // change text & placeholder color
                          opacity: 1,
                        },
                      },
                    },
                  }}
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/calendar_icon.svg" alt="icon" />
                    ),
                  }}
                  disabled={!date}
                />
              </LocalizationProvider>
              {error && !time ? (
                <p className="err_msg">Time is required</p>
              ) : (
                ""
              )}
            </div>

            {questions?.map((q: any) => (
              <div key={q?.id} style={{ marginBottom: 20 }}>
                <label>{q?.label}</label>

                {renderField(q)}
              </div>
            ))}

            {isCancellationPolicy && (
              <div className="control_group w_100">
                <p className="note">
                  Please note: By proceeding, you agree to our cancellation
                  policy.
                </p>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <Checkbox
                    checked={acceptPolicy}
                    onChange={(e) => setAcceptPolicy(e.target.checked)}
                  />
                  <label style={{ marginTop: "18px" }}>
                    I accept the cancellation policy
                  </label>
                </div>
              </div>
            )}
          </div>
          <div className="mt_30">
            <Button
              className="btn btn_primary"
              onClick={() => {
                isEdit ? editBookingApi() : addUserApi();
              }}
            >
              Save
            </Button>
          </div>
        </div>
      )}
    </MainContainer>
  );
}
export default AddUserLink;
